<template>
  <v-switch
    hide-details
    v-model="value"
    :loading="loading"
    inset
    label="Délégué·e du personnel ? "
    @change="changerEstDelegueDuPersonnel"
  />
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    estDelegueDuPersonnel: {
      type: Boolean,
      required: true,
    },
    employeId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      value: this.estDelegueDuPersonnel,
      loading: false,
    }
  },
  methods: {
    ...mapActions({
      changerDelegueDuPersonnel: 'employe/changerEstDelegueDuPersonnel',
    }),
    changerEstDelegueDuPersonnel(estDelegueDuPersonnel) {
      this.loading = true
      this.changerDelegueDuPersonnel({
        _employeId: this.employeId,
        estDelegueDuPersonnel: estDelegueDuPersonnel,
      }).then((res) => {
        this.loading = false
        this.value = res.delegueDuPersonnel
      })
    },
  },
}
</script>
